import * as React from 'react';
import { SVG_TYPE } from 'shared/consts';

const SVG = ({ type, className = '' }) => {
  switch (type) {
    case SVG_TYPE.START: {
      return (
        <svg
          className={`svg svg--start ${className}`}
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(-2.5 -2.5)">
            <path
              className="b"
              d="M24.5,13.944a9.311,9.311,0,0,1-1,4.222,9.444,9.444,0,0,1-8.444,5.222,9.311,9.311,0,0,1-4.222-1L4.5,24.5l2.111-6.333a9.311,9.311,0,0,1-1-4.222A9.444,9.444,0,0,1,10.833,5.5a9.311,9.311,0,0,1,4.222-1h.556A9.422,9.422,0,0,1,24.5,13.389Z"
            />
            <path
              className="c"
              d="M 15.03121566772461 4.499959945678711 C 13.573073387146 4.499959945678711 12.13507461547852 4.842473983764648 10.83332633972168 5.499992370605469 C 7.634075164794922 7.098922729492188 5.612495422363281 10.36786270141602 5.611104965209961 13.94442176818848 C 5.60728645324707 15.41094207763672 5.949916839599609 16.85762214660645 6.611104965209961 18.1666316986084 L 4.499996185302734 24.49996185302734 L 10.83332633972168 22.38885116577148 C 12.13514518737793 23.04640007019043 13.57304382324219 23.38888359069824 15.03127861022949 23.38888359069824 C 15.03933238983154 23.38888359069824 15.04748058319092 23.38887405395508 15.0555362701416 23.38885116577148 C 18.63209533691406 23.3874626159668 21.90103530883789 21.36588287353516 23.49996566772461 18.1666316986084 C 24.16115570068359 16.85762214660645 24.5037956237793 15.41093254089355 24.49996566772461 13.94442176818848 L 24.49996566772461 13.38886260986328 C 24.23541641235352 8.593532562255859 20.40642547607422 4.764541625976563 15.6110954284668 4.499992370605469 L 15.0555362701416 4.499992370605469 C 15.04739093780518 4.499971389770508 15.0393590927124 4.499959945678711 15.03121566772461 4.499959945678711 M 15.03121566772461 2.499961853027344 L 15.06044578552246 2.500001907348633 L 15.6110954284668 2.499992370605469 C 15.64783573150635 2.499992370605469 15.6845760345459 2.501001358032227 15.72126579284668 2.503032684326172 C 21.54321670532227 2.824213027954102 26.17574691772461 7.456741333007813 26.49692535400391 13.2786922454834 C 26.49895668029785 13.31538200378418 26.49996566772461 13.35212230682373 26.49996566772461 13.38886260986328 L 26.49996566772461 13.94387626647949 C 26.50386238098145 15.71326637268066 26.08478927612305 17.48306274414063 25.28791809082031 19.06286811828613 C 24.33723449707031 20.96407699584961 22.87921333312988 22.55990219116211 21.0713062286377 23.67794227600098 C 19.26273727416992 24.79640197753906 17.18278503417969 25.38802146911621 15.05631637573242 25.38885116577148 L 15.03127574920654 25.38888168334961 C 13.55760288238525 25.38888168334961 12.08359146118164 25.09534072875977 10.72038078308105 24.53469085693359 L 5.132455825805664 26.39733123779297 C 4.925241470336914 26.46640205383301 4.711811065673828 26.5000171661377 4.500267028808594 26.5000171661377 C 3.978122711181641 26.5000171661377 3.466999053955078 26.2953929901123 3.085786819458008 25.9141731262207 C 2.550115585327148 25.37851142883301 2.363075256347656 24.58617210388184 2.602626800537109 23.86750221252441 L 4.465261459350586 18.27959442138672 C 3.900819778442383 16.90725708007813 3.607250213623047 15.42304420471191 3.611116409301758 13.93921184539795 C 3.611936569213867 11.81717300415039 4.203556060791016 9.737222671508789 5.322015762329102 7.928651809692383 C 6.440055847167969 6.120744705200195 8.035873413085938 4.662727355957031 9.937084197998047 3.712043762207031 C 11.5091381072998 2.919073104858398 13.27050971984863 2.499961853027344 15.03121566772461 2.499961853027344 Z"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.SOLD: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.71" height="9.228" viewBox="0 0 10.71 9.228">
          <path
            id="sold"
            d="M4.339,7.52a.854.854,0,1,0,.84.854A.839.839,0,0,0,4.339,7.52Zm3.97,0a.854.854,0,1,0,.84.854A.847.847,0,0,0,8.309,7.52Zm2.06-4.81s-.393-.339-.65.474C9.312,4.688,8.8,6.165,8.8,6.165H3.946L3.363,3.415,2.93.949A.5.5,0,0,0,2.577.542L.585.027A.425.425,0,0,0,.016.312.445.445,0,0,0,.355.867L2.144,1.3l.921,5.163s.027.583.542.583H9.054a.55.55,0,0,0,.515-.461L10.6,3.361a.385.385,0,0,0-.23-.65ZM5.924,1.965,4.678,3.211a.262.262,0,0,0,0,.379l.257.257a.262.262,0,0,0,.379,0L6.561,2.6,7.808,3.848a.262.262,0,0,0,.379,0l.257-.257a.262.262,0,0,0,0-.379L7.2,1.965,8.444.718a.262.262,0,0,0,0-.379L8.187.081a.262.262,0,0,0-.379,0L6.561,1.328,5.314.081a.262.262,0,0,0-.379,0L4.691.339a.262.262,0,0,0,0,.379Z"
          />
        </svg>
      );
    }
    case SVG_TYPE.ZERO: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8.727" height="9.614" viewBox="0 0 8.727 9.614">
          <path
            id="zero"
            d="M8.6.52a.436.436,0,0,0-.616,0L6.676,1.827A2.8,2.8,0,0,0,4.307,0c-1.681,0-3,2.112-3,4.807A7.441,7.441,0,0,0,1.6,6.9L.128,8.375a.436.436,0,1,0,.616.616l1.2-1.2A2.793,2.793,0,0,0,4.307,9.614c1.681,0,3-2.112,3-4.807a7.441,7.441,0,0,0-.287-2.088L8.6,1.137A.436.436,0,0,0,8.6.52ZM2.181,4.807c0-2.133.974-3.935,2.126-3.935.689,0,1.314.644,1.706,1.619L2.32,6.183a6.736,6.736,0,0,1-.14-1.376Zm4.253,0c0,2.133-.974,3.935-2.126,3.935C3.62,8.742,3,8.1,2.6,7.132L6.3,3.44a6.76,6.76,0,0,1,.138,1.366Z"
          />
        </svg>
      );
    }
    case SVG_TYPE.NAVIGATE: {
      return (
        <svg
          className={`svg svg--navigate ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="11.2"
          viewBox="0 0 10 11.2"
        >
          <path
            className="a"
            d="M3.6,3l.852.852L2.3,6H7.8V0H9V7.2H2.3L4.452,9.348,3.6,10.2,0,6.6Z"
            transform="translate(9.5 10.7) rotate(180)"
          />
        </svg>
      );
    }
    case SVG_TYPE.ARROW_GRAY: {
      return (
        <svg
          className={`svg svg--arrow-gray ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="16.811"
          height="8.263"
          viewBox="0 0 16.811 8.263"
        >
          <path
            className="a"
            d="M11.78,12.889H.45a.45.45,0,0,0-.45.45v2.1a.45.45,0,0,0,.45.45H11.78v1.728a.9.9,0,0,0,1.537.637l3.229-3.229a.9.9,0,0,0,0-1.274l-3.229-3.229a.9.9,0,0,0-1.537.637Z"
            transform="translate(0 -10.258)"
          />
        </svg>
      );
    }
    case SVG_TYPE.DOT: {
      return (
        <svg
          className={`svg svg--dot ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewBox="0 0 11 11"
        >
          <circle className="a" cx="5.5" cy="5.5" r="5.5" />
        </svg>
      );
    }
    case SVG_TYPE.BACK: {
      return (
        <svg
          className={`svg svg--back ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="6.667"
          height="10.506"
          viewBox="0 0 6.667 10.506"
        >
          <path className="a" d="M14685.494-4154.571l-3.839,3.839,3.839,3.839" transform="translate(-14680.241 4155.985)" />
        </svg>
      );
    }
    case SVG_TYPE.DOWNLOAD: {
      return (
        <svg
          className={`svg svg--download ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="19.3"
          height="23.375"
          viewBox="0 0 19.3 23.375"
        >
          <g transform="translate(-4.5 -1.5)">
            <path
              className="a"
              d="M6,18v8.15a2.038,2.038,0,0,0,2.038,2.038H20.263A2.038,2.038,0,0,0,22.3,26.15V18"
              transform="translate(0 -4.812)"
            />
            <path className="a" d="M20.15,7.075,16.075,3,12,7.075" transform="translate(-1.925)" />
            <path className="a" d="M18,3V16.244" transform="translate(-3.85)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.SETTLEMENTS: {
      return (
        <svg
          className={`svg svg--settlement ${className}`}
          height="24"
          viewBox="0 0 22 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(2 2)">
            <g className="a" transform="translate(-4.5 -3)">
              <path className="c" d="M4.5,10l9-7,9,7V21a2,2,0,0,1-2,2H6.5a2,2,0,0,1-2-2Z" />
              <path
                className="d"
                d="M 13.50000286102295 3 L 4.500001907348633 10 L 4.500001907348633 21 C 4.500001907348633 22.10457038879395 5.39543342590332 23 6.500001907348633 23 L 20.50000381469727 23 C 21.60457229614258 23 22.50000381469727 22.10457038879395 22.50000381469727 21 L 22.50000381469727 10 L 13.50000286102295 3 M 13.50000286102295 1.000001907348633 C 13.93338775634766 1.000001907348633 14.36677265167236 1.140434265136719 14.72788238525391 1.421300888061523 L 23.72788238525391 8.421300888061523 C 24.21505355834961 8.800210952758789 24.50000381469727 9.382820129394531 24.50000381469727 10 L 24.50000381469727 21 C 24.50000381469727 23.20561027526855 22.70561218261719 25 20.50000381469727 25 L 6.500001907348633 25 C 4.294393539428711 25 2.500001907348633 23.20561027526855 2.500001907348633 21 L 2.500001907348633 10 C 2.500001907348633 9.382820129394531 2.784952163696289 8.800210952758789 3.272123336791992 8.421300888061523 L 12.27212333679199 1.421300888061523 C 12.63323307037354 1.140434265136719 13.06661796569824 1.000001907348633 13.50000286102295 1.000001907348633 Z"
              />
            </g>
            <path className="b" d="M13.5,30.038V18h7.223V30.038" transform="translate(-8.111 -10.038)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.INVESTORS: {
      return (
        <svg
          className={`svg svg--investors ${className}`}
          height="24"
          viewBox="0 0 32.571 24"
          width="32.571"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(2 -0.25)">
            <path
              className="b"
              d="M8.571,12.25a5,5,0,1,0-5-5A5,5,0,0,0,8.571,12.25ZM12,13.679h-.371a6.9,6.9,0,0,1-6.116,0H5.143A5.144,5.144,0,0,0,0,18.821v1.286A2.143,2.143,0,0,0,2.143,22.25H15a2.143,2.143,0,0,0,2.143-2.143V18.821A5.144,5.144,0,0,0,12,13.679Zm9.429-1.429a4.286,4.286,0,1,0-4.286-4.286A4.287,4.287,0,0,0,21.429,12.25Zm2.143,1.429H23.4a5.63,5.63,0,0,1-3.946,0h-.17a4.958,4.958,0,0,0-2.487.688,6.533,6.533,0,0,1,1.772,4.455v1.714c0,.1-.022.192-.027.286h7.884a2.143,2.143,0,0,0,2.143-2.143,5,5,0,0,0-5-5Z"
            />
            <path
              className="c"
              d="M 15.00000381469727 22.25 C 16.18303489685059 22.25 17.14285469055176 21.29018020629883 17.14285469055176 20.10713958740234 L 17.14285469055176 18.82143020629883 C 17.14285469055176 15.98213958740234 14.83928394317627 13.67856979370117 12.00000381469727 13.67856979370117 L 11.6294641494751 13.67856979370117 C 10.70089435577393 14.125 9.669644355773926 14.39286041259766 8.57142448425293 14.39286041259766 C 7.473214149475098 14.39286041259766 6.446424007415771 14.125 5.513394355773926 13.67856979370117 L 5.1428542137146 13.67856979370117 C 2.303574085235596 13.67856979370117 4.149474989390001e-06 15.98213958740234 4.149474989390001e-06 18.82143020629883 L 4.149474989390001e-06 20.10713958740234 C 4.149474989390001e-06 21.29018020629883 0.9598241448402405 22.25 2.1428542137146 22.25 L 15.00000381469727 22.25 M 26.42857360839844 20.82143020629883 C 27.61160469055176 20.82143020629883 28.57142448425293 19.86161041259766 28.57142448425293 18.67856979370117 C 28.57142448425293 15.91518020629883 26.33482360839844 13.67856979370117 23.57143402099609 13.67856979370117 L 23.40178489685059 13.67856979370117 C 22.7812442779541 13.89286041259766 22.1249942779541 14.03571033477783 21.42857360839844 14.03571033477783 C 20.73214340209961 14.03571033477783 20.07589340209961 13.89286041259766 19.45535469055176 13.67856979370117 L 19.28571319580078 13.67856979370117 C 18.37500381469727 13.67856979370117 17.53571319580078 13.941969871521 16.79910469055176 14.36606979370117 C 17.88839340209961 15.54018020629883 18.57142448425293 17.09822082519531 18.57142448425293 18.82143020629883 L 18.57142448425293 20.53572082519531 C 18.57142448425293 20.63393020629883 18.54910469055176 20.72768020629883 18.54464340209961 20.82143020629883 L 26.42857360839844 20.82143020629883 M 21.42857360839844 12.25 C 23.79464340209961 12.25 25.71428489685059 10.33036041259766 25.71428489685059 7.964290142059326 C 25.71428489685059 5.598209857940674 23.79464340209961 3.678570032119751 21.42857360839844 3.678570032119751 C 19.06250381469727 3.678570032119751 17.14285469055176 5.598209857940674 17.14285469055176 7.964290142059326 C 17.14285469055176 10.33036041259766 19.06250381469727 12.25 21.42857360839844 12.25 M 8.57142448425293 12.25 C 11.33482456207275 12.25 13.57142448425293 10.01338958740234 13.57142448425293 7.25 C 13.57142448425293 4.486609935760498 11.33482456207275 2.25 8.57142448425293 2.25 C 5.80803394317627 2.25 3.571424245834351 4.486609935760498 3.571424245834351 7.25 C 3.571424245834351 10.01338958740234 5.80803394317627 12.25 8.57142448425293 12.25 M 15.00000381469727 24.25 L 2.1428542137146 24.25 C -0.1415258496999741 24.25 -1.999995827674866 22.39151954650879 -1.999995827674866 20.10713958740234 L -1.999995827674866 18.82143020629883 C -1.999995827674866 15.50209140777588 0.2759177982807159 12.70430850982666 3.349188804626465 11.90659427642822 C 2.244104146957397 10.6685037612915 1.571424126625061 9.036198616027832 1.571424126625061 7.25 C 1.571424126625061 3.39018988609314 4.71161413192749 0.25 8.57142448425293 0.25 C 12.00294208526611 0.25 14.86567783355713 2.731959104537964 15.45873737335205 5.995000839233398 C 16.28694915771484 3.490636110305786 18.65013694763184 1.678570032119751 21.42857360839844 1.678570032119751 C 24.89452362060547 1.678570032119751 27.71428489685059 4.498330116271973 27.71428489685059 7.964290142059326 C 27.71428489685059 9.572665214538574 27.10705375671387 11.04190349578857 26.10982894897461 12.15476989746094 C 28.71834754943848 13.17338848114014 30.57142448425293 15.71374416351318 30.57142448425293 18.67856979370117 C 30.57142448425293 20.96294975280762 28.71295356750488 22.82143020629883 26.42857360839844 22.82143020629883 L 18.54464340209961 22.82143020629883 C 18.41438865661621 22.82143020629883 18.28543663024902 22.8087158203125 18.15953254699707 22.78401184082031 C 17.39901161193848 23.68024253845215 16.26475143432617 24.25 15.00000381469727 24.25 Z M 13.79366111755371 11.90659141540527 C 14.4678316116333 12.08158302307129 15.10373020172119 12.35286903381348 15.68555068969727 12.70474338531494 C 15.72313117980957 12.67955875396729 15.76169776916504 12.65555953979492 15.801194190979 12.63282012939453 C 16.11473274230957 12.45229816436768 16.43421363830566 12.2971305847168 16.75879859924316 12.16755771636963 C 16.03104782104492 11.35980796813965 15.50924110412598 10.36279392242432 15.27723407745361 9.260516166687012 C 14.97929286956787 10.25247192382813 14.46659374237061 11.15266609191895 13.79366111755371 11.90659141540527 Z"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.EMPLOYEES: {
      return (
        <svg
          className={`svg svg--employees ${className}`}
          height="24"
          viewBox="0 0 21.501 24"
          // width="21.501"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(2 1.999)">
            <path
              className="b"
              d="M15,12.044,15.93,9.6a.624.624,0,0,0-.586-.848H13.059a4.953,4.953,0,0,0,.7-2.5V6.239c1.531-.3,2.5-.746,2.5-1.238,0-.52-1.066-.98-2.738-1.289A10.134,10.134,0,0,0,11.93.477,1.254,1.254,0,0,0,10.387.133L9.309.672a1.249,1.249,0,0,1-1.117,0L7.113.133A1.254,1.254,0,0,0,5.57.477,10.216,10.216,0,0,0,3.984,3.711C2.316,4.02,1.25,4.481,1.25,5c0,.492.969.934,2.5,1.238v.012a4.953,4.953,0,0,0,.7,2.5H2.2a.625.625,0,0,0-.574.871l1.008,2.352A5.233,5.233,0,0,0,0,16.5v1.75A1.752,1.752,0,0,0,1.75,20h14a1.752,1.752,0,0,0,1.75-1.75V16.5A5.235,5.235,0,0,0,15,12.044ZM6.875,18.751l-1.625-7.5L7.188,12.5l.938,1.563Zm3.75,0-1.25-4.688.938-1.563,1.938-1.25ZM12.254,7.09a2.873,2.873,0,0,1-.645,1.3c-.395.363-1.875.875-2.5-.977a.383.383,0,0,0-.715,0c-.664,1.961-2.188,1.266-2.5.977a2.835,2.835,0,0,1-.645-1.3C5.219,6.993,5,6.868,5,6.864V6.442a30.082,30.082,0,0,0,3.75.227,29.351,29.351,0,0,0,3.75-.227v.422S12.286,6.989,12.254,7.09Z"
            />
            <path
              className="c"
              d="M 15.75044822692871 20.00102043151855 C 16.71531867980957 20.00102043151855 17.50049781799316 19.21584129333496 17.50049781799316 18.2509708404541 L 17.50049781799316 16.50092124938965 C 17.50049781799316 14.6102409362793 16.4926586151123 12.96957111358643 14.9965181350708 12.04376125335693 L 15.93013763427734 9.598381042480469 C 16.08639717102051 9.188210487365723 15.78560829162598 8.750700950622559 15.34418773651123 8.750700950622559 L 13.05896759033203 8.750700950622559 C 13.48866748809814 8.01240062713623 13.75429821014404 7.164721012115479 13.75429821014404 6.250630855560303 L 13.75429821014404 6.238911151885986 C 15.28558826446533 5.934220790863037 16.25436782836914 5.492800712585449 16.25436782836914 5.000590801239014 C 16.25436782836914 4.481050968170166 15.18792819976807 4.020101070404053 13.5160083770752 3.711500883102417 C 13.1566276550293 2.430210828781128 12.46128749847412 1.141110897064209 11.93002796173096 0.4770309329032898 C 11.68370056152344 0.1684767156839371 11.31853675842285 0.001024612109176815 10.94551944732666 0.001024612109176815 C 10.75655937194824 0.001024612109176815 10.56564998626709 0.04395479708909988 10.38701820373535 0.1332709342241287 L 9.308857917785645 0.6723509430885315 C 9.133072853088379 0.760240912437439 8.94166088104248 0.8041859269142151 8.750247955322266 0.8041859269142151 C 8.558835029602051 0.8041859269142151 8.367423057556152 0.760240912437439 8.191637992858887 0.6723509430885315 L 7.113487720489502 0.1332709342241287 C 6.934884548187256 0.04397100955247879 6.743907928466797 0.001024612109176815 6.554978847503662 0.001024612109176815 C 6.181923866271973 0.001024612109176815 5.816817760467529 0.168448343873024 5.570467948913574 0.4770309329032898 C 5.043107986450195 1.141110897064209 4.343877792358398 2.430210828781128 3.984488010406494 3.711500883102417 C 2.316468000411987 4.020101070404053 1.250037908554077 4.481050968170166 1.250037908554077 5.000600814819336 C 1.250037908554077 5.492800712585449 2.218817949295044 5.934220790863037 3.750108003616333 6.238911151885986 L 3.750108003616333 6.250630855560303 C 3.750108003616333 7.164721012115479 4.015738010406494 8.01240062713623 4.445437908172607 8.750700950622559 L 2.199277877807617 8.750700950622559 C 1.750047922134399 8.750700950622559 1.449257969856262 9.207751274108887 1.625047922134399 9.621821403503418 L 2.632887840270996 11.97345066070557 C 1.066437959671021 12.88363075256348 -2.044677785306703e-06 14.55946063995361 -2.044677785306703e-06 16.50092124938965 L -2.044677785306703e-06 18.2509708404541 C -2.044677785306703e-06 19.21584129333496 0.7851779460906982 20.00102043151855 1.750047922134399 20.00102043151855 L 15.75044822692871 20.00102043151855 M 12.25034809112549 11.25077056884766 L 10.62529754638672 18.75099182128906 L 9.37526798248291 14.06335067749023 L 10.31279754638672 12.50081062316895 L 12.25034809112549 11.25077056884766 M 5.250147819519043 11.25077056884766 L 7.187707901000977 12.50081062316895 L 8.125227928161621 14.06335067749023 L 6.875197887420654 18.75099182128906 L 5.250147819519043 11.25077056884766 M 5.004047870635986 6.442040920257568 C 6.109548091888428 6.582671165466309 7.386928081512451 6.6686110496521 8.754158020019531 6.6686110496521 C 10.12137794494629 6.6686110496521 11.39875793457031 6.586580753326416 12.50425815582275 6.442040920257568 L 12.50425815582275 6.863930702209473 C 12.50035762786865 6.867840766906738 12.28550815582275 6.988930702209473 12.25425815582275 7.090500831604004 C 12.10190773010254 7.555360794067383 11.98080825805664 8.051461219787598 11.60970783233643 8.395220756530762 C 11.43454456329346 8.556510925292969 11.04531764984131 8.747062683105469 10.61194133758545 8.747062683105469 C 10.06917858123779 8.747062683105469 9.457162857055664 8.448187828063965 9.109638214111328 7.418631076812744 C 9.054947853088379 7.254565715789795 8.904553413391113 7.172533512115479 8.753668785095215 7.172533512115479 C 8.602785110473633 7.172533512115479 8.451413154602051 7.254565715789795 8.394767761230469 7.418631076812744 C 8.041043281555176 8.463165283203125 7.443337440490723 8.754042625427246 6.914838314056396 8.754097938537598 C 6.451137542724609 8.754146575927734 6.040748119354248 8.530316352844238 5.894698143005371 8.395220756530762 C 5.523597717285156 8.051461219787598 5.398588180541992 7.555360794067383 5.250147819519043 7.090500831604004 C 5.218897819519043 6.992840766906738 5.004047870635986 6.867840766906738 5.004047870635986 6.863930702209473 L 5.004047870635986 6.442040920257568 M 15.75044822692871 22.00102043151855 L 1.750047922134399 22.00102043151855 C -0.317732036113739 22.00102043151855 -2.000002145767212 20.31875038146973 -2.000002145767212 18.2509708404541 L -2.000002145767212 16.50092124938965 C -2.000002145767212 15.20621109008789 -1.650312066078186 13.93547058105469 -0.988722026348114 12.82608127593994 C -0.6641182899475098 12.28176021575928 -0.26840940117836 11.78205490112305 0.185390904545784 11.33980560302734 L -0.2132420390844345 10.40966129302979 C -0.2141420394182205 10.40757083892822 -0.2150320410728455 10.40548133850098 -0.2159220427274704 10.40339088439941 C -0.561672031879425 9.588971138000488 -0.4769520461559296 8.662860870361328 0.01070795487612486 7.926041126251221 C 0.1829351484775543 7.665822505950928 0.3965166509151459 7.442706108093262 0.6397645473480225 7.262954711914063 C -0.558180034160614 6.519577503204346 -0.7499620318412781 5.546408653259277 -0.7499620318412781 5.000600814819336 C -0.7499620318412781 4.379490852355957 -0.5024420619010925 3.223541021347046 1.155297994613647 2.46026086807251 C 1.520878553390503 2.291932582855225 1.956678748130798 2.139659881591797 2.457959175109863 2.004814147949219 C 2.916388034820557 0.8627528548240662 3.518259048461914 -0.1547560691833496 4.004248142242432 -0.7667390704154968 C 4.005318164825439 -0.7680790424346924 4.006388187408447 -0.769429087638855 4.007457733154297 -0.7707690596580505 C 4.630598068237305 -1.551319003105164 5.559127807617188 -1.998979091644287 6.554977893829346 -1.998979091644287 C 7.056198120117188 -1.998979091644287 7.558608055114746 -1.880239009857178 8.007918357849121 -1.655579090118408 L 8.750249862670898 -1.284409880638123 L 9.492588043212891 -1.655579090118408 C 9.941858291625977 -1.880229115486145 10.4442777633667 -1.998979091644287 10.94551753997803 -1.998979091644287 C 11.94135761260986 -1.998979091644287 12.86988830566406 -1.551319003105164 13.49302768707275 -0.7707790732383728 C 13.97876071929932 -0.1636149436235428 14.58243560791016 0.854744017124176 15.04299926757813 2.00439453125 C 15.5452823638916 2.13923978805542 15.98177242279053 2.291526556015015 16.34789848327637 2.459930896759033 C 18.00668716430664 3.222900867462158 18.25436782836914 4.379220962524414 18.25436782836914 5.000590801239014 C 18.25436782836914 5.543120384216309 18.06487464904785 6.507906436920166 16.88611030578613 7.249539852142334 C 17.12524032592773 7.42249870300293 17.33638954162598 7.636651515960693 17.50830841064453 7.886120796203613 C 17.99799728393555 8.596691131591797 18.10670852661133 9.502961158752441 17.79910850524902 10.31039047241211 L 17.38419151306152 11.3971529006958 C 18.73055076599121 12.73937511444092 19.50049781799316 14.5556468963623 19.50049781799316 16.50092124938965 L 19.50049781799316 18.2509708404541 C 19.50049781799316 20.31875038146973 17.81822776794434 22.00102043151855 15.75044822692871 22.00102043151855 Z"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.PARTNERS: {
      return (
        <svg
          className={`svg svg--partners ${className}`}
          // height="17"
          height="24"
          viewBox="0 0 15.375 17"
          // width="15.375"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(2 2)">
            <path
              className="b"
              d="M5.688,6.5a3.25,3.25,0,1,0-3.25-3.25A3.25,3.25,0,0,0,5.688,6.5Zm2.432.828-1.214,4.86L6.094,8.734l.813-1.422H4.469l.812,1.422-.812,3.453L3.255,7.328A3.407,3.407,0,0,0,0,10.725v1.056A1.219,1.219,0,0,0,1.219,13h8.938a1.219,1.219,0,0,0,1.219-1.219V10.725A3.407,3.407,0,0,0,8.12,7.328Z"
            />
            <path
              className="c"
              d="M 5.6875 0 C 3.892380237579346 0 2.4375 1.454879760742188 2.4375 3.25 C 2.4375 5.045119762420654 3.892380237579346 6.5 5.6875 6.5 C 7.482620239257813 6.5 8.9375 5.045119762420654 8.9375 3.25 C 8.9375 1.454879760742188 7.482620239257813 0 5.6875 0 M 4.46875 7.3125 L 5.28125 8.734379768371582 L 4.46875 12.1875 L 3.255080223083496 7.32774019241333 C 1.444729804992676 7.414060115814209 0 8.894340515136719 0 10.72500038146973 L 0 11.78125 C 0 12.45409965515137 0.5459003448486328 13 1.21875 13 L 10.15625 13 C 10.82909965515137 13 11.375 12.45409965515137 11.375 11.78125 L 11.375 10.72500038146973 C 11.375 8.894340515136719 9.930279731750488 7.414060115814209 8.119919776916504 7.32774019241333 L 6.90625 12.1875 L 6.09375 8.734379768371582 L 6.90625 7.3125 L 4.46875 7.3125 M 5.6875 -2 C 8.58236026763916 -2 10.9375 0.3551397323608398 10.9375 3.25 C 10.9375 4.188037872314453 10.69022750854492 5.069378852844238 10.25741863250732 5.832309722900391 C 12.10713481903076 6.695559501647949 13.375 8.565539360046387 13.375 10.72500038146973 L 13.375 11.78125 C 13.375 13.55607032775879 11.93107032775879 15 10.15625 15 L 1.21875 15 C -0.5560703277587891 15 -2 13.55607032775879 -2 11.78125 L -2 10.72500038146973 C -2 8.565539360046387 -0.7321348190307617 6.695559501647949 1.117581367492676 5.832309722900391 C 0.6847724914550781 5.069378852844238 0.4375 4.188037872314453 0.4375 3.25 C 0.4375 0.3551397323608398 2.79263973236084 -2 5.6875 -2 Z"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.CALENDAR: {
      return (
        <svg
          className={`svg svg--calendar ${className}`}
          height="23"
          viewBox="0 0 22 23"
          width="22"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(-2.5 -2)">
            <g className="b" transform="translate(0 -1)">
              <path className="d" d="M6.5,6h14a2,2,0,0,1,2,2V22a2,2,0,0,1-2,2H6.5a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2Z" />
              <path
                className="e"
                d="M 6.5 5.999998092651367 C 5.395429611206055 5.999998092651367 4.5 6.895429611206055 4.5 7.999998092651367 L 4.5 22 C 4.5 23.10456848144531 5.395429611206055 24 6.5 24 L 20.5 24 C 21.60457038879395 24 22.5 23.10456848144531 22.5 22 L 22.5 7.999998092651367 C 22.5 6.895429611206055 21.60457038879395 5.999998092651367 20.5 5.999998092651367 L 6.5 5.999998092651367 M 6.5 3.999998092651367 L 20.5 3.999998092651367 C 22.70561027526855 3.999998092651367 24.5 5.794389724731445 24.5 7.999998092651367 L 24.5 22 C 24.5 24.20560836791992 22.70561027526855 26 20.5 26 L 6.5 26 C 4.294389724731445 26 2.5 24.20560836791992 2.5 22 L 2.5 7.999998092651367 C 2.5 5.794389724731445 4.294389724731445 3.999998092651367 6.5 3.999998092651367 Z"
              />
            </g>
            <path className="c" d="M24,3V7" transform="translate(-6.5)" />
            <path className="c" d="M12,3V7" transform="translate(-2.5)" />
            <path className="c" d="M4.5,15h18" transform="translate(0 -4)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.SETTINGS: {
      return (
        <svg
          className={`svg svg--settings ${className}`}
          height="21.405"
          viewBox="0 0 21.405 21.405"
          width="21.405"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g className="a" transform="translate(1 1)">
            <path
              className="b"
              d="M18.792,16.146A2.646,2.646,0,1,1,16.146,13.5,2.646,2.646,0,0,1,18.792,16.146Z"
              transform="translate(-6.443 -6.444)"
            />
            <path
              className="b"
              d="M17.73,13.849a1.455,1.455,0,0,0,.291,1.605l.053.053a1.765,1.765,0,1,1-2.5,2.5l-.053-.053a1.467,1.467,0,0,0-2.487,1.041v.15a1.764,1.764,0,0,1-3.528,0v-.079a1.455,1.455,0,0,0-.953-1.332,1.455,1.455,0,0,0-1.605.291l-.053.053a1.765,1.765,0,1,1-2.5-2.5l.053-.053a1.467,1.467,0,0,0-1.041-2.487h-.15a1.764,1.764,0,1,1,0-3.528h.079a1.455,1.455,0,0,0,1.332-.953,1.455,1.455,0,0,0-.291-1.605L4.331,6.9a1.765,1.765,0,1,1,2.5-2.5l.053.053a1.455,1.455,0,0,0,1.605.291h.071a1.455,1.455,0,0,0,.882-1.332v-.15a1.764,1.764,0,0,1,3.528,0v.079a1.467,1.467,0,0,0,2.487,1.041l.053-.053a1.765,1.765,0,1,1,2.5,2.5l-.053.053a1.455,1.455,0,0,0-.291,1.605v.071a1.455,1.455,0,0,0,1.332.882h.15a1.764,1.764,0,1,1,0,3.528h-.079a1.455,1.455,0,0,0-1.332.882Z"
              transform="translate(-1.5 -1.5)"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.LOUPE: {
      return (
        <svg
          className={`svg svg--loupe ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="21.285"
          height="21.289"
          viewBox="0 0 21.285 21.289"
        >
          <path
            className="a"
            d="M21,18.405,16.85,14.26a1,1,0,0,0-.707-.291h-.678a8.644,8.644,0,1,0-1.5,1.5v.678a1,1,0,0,0,.291.707L18.405,21a.994.994,0,0,0,1.409,0l1.177-1.177A1,1,0,0,0,21,18.405ZM8.648,13.969a5.322,5.322,0,1,1,5.322-5.322A5.319,5.319,0,0,1,8.648,13.969Z"
          />
        </svg>
      );
    }
    case SVG_TYPE.FILTER: {
      return (
        <svg
          className={`svg svg--filter ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="17.5"
          height="15.95"
          viewBox="0 0 17.5 15.95"
        >
          <g transform="translate(-265 -88)">
            <path className="a" d="M18.5,4.5H3l6.2,7.332V16.9l3.1,1.55V11.832Z" transform="translate(263 84.5)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.ADD: {
      return (
        <svg
          className={`svg svg--add ${className}`}
          height="20.843"
          viewBox="0 0 20.844 20.843"
          width="20.844"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(1.5 1.5)">
            <line className="a" transform="translate(8.922)" y2="17.843" />
            <line className="a" transform="translate(17.844 8.922) rotate(90)" y2="17.844" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.PHONE: {
      return (
        <svg
          className={`svg svg--phone ${className}`}
          height="17.07"
          viewBox="0 0 17.038 17.07"
          width="17.038"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="a"
            d="M13.721,4.763a4.078,4.078,0,0,1,3.222,3.222M13.721,1.5a7.341,7.341,0,0,1,6.485,6.476m-.816,6.509v2.447a1.631,1.631,0,0,1-1.778,1.631,16.142,16.142,0,0,1-7.039-2.5,15.906,15.906,0,0,1-4.894-4.894,16.142,16.142,0,0,1-2.5-7.072A1.631,1.631,0,0,1,4.8,2.316H7.245a1.631,1.631,0,0,1,1.631,1.4,10.473,10.473,0,0,0,.571,2.292A1.631,1.631,0,0,1,9.08,7.732L8.044,8.768a13.051,13.051,0,0,0,4.894,4.894l1.036-1.036a1.631,1.631,0,0,1,1.721-.367,10.473,10.473,0,0,0,2.292.571A1.631,1.631,0,0,1,19.39,14.485Z"
            transform="translate(-3.168 -1.5)"
          />
        </svg>
      );
    }
    case SVG_TYPE.CONFIRM: {
      return (
        <svg
          className={`svg svg--confirm ${className}`}
          height="8.032"
          viewBox="0 0 10.988 8.032"
          width="10.988"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className="a" d="M299.333,15.853l2.956,2.956,5.2-5.2" transform="translate(-297.919 -12.192)" />
        </svg>
      );
    }
    case SVG_TYPE.DROPDOWN_INDICATOR: {
      return (
        <svg
          className={`svg svg--dropdown-indicator ${className}`}
          height="9.909"
          viewBox="0 0 15.575 9.909"
          width="15.575"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path className="a" d="M11705.538,192l-5.667,5.667-5.666-5.667" transform="translate(-11692.084 -189.879)" />
        </svg>
      );
    }
    case SVG_TYPE.MEDIA_WATER: {
      return (
        <svg
          className={`svg svg--media_water ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="8.26"
          height="10.739"
          viewBox="0 0 8.26 10.739"
        >
          <path
            className="a"
            d="M13.358,5.914a11.543,11.543,0,0,0-2.344-2.494.221.221,0,0,0-.268,0A11.4,11.4,0,0,0,8.41,5.909a7.83,7.83,0,0,0-1.657,4.411c0,.031,0,.065,0,.1a3.373,3.373,0,0,0,.281,1.345,3.627,3.627,0,0,0,.392.679,4.261,4.261,0,0,0,3.454,1.673,3.933,3.933,0,0,0,4.133-3.7A7.861,7.861,0,0,0,13.358,5.914Zm-2.22,6.822h-.013a.226.226,0,0,1-.067-.441,3.214,3.214,0,0,0,2.23-2.086.225.225,0,0,1,.434.08v.036A2.5,2.5,0,0,1,11.138,12.737Z"
            transform="translate(-6.75 -3.374)"
          />
        </svg>
      );
    }
    case SVG_TYPE.MEDIA_TELECOMUNICATION: {
      return (
        <svg
          className={`svg svg--media_telecomunication ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="10.129"
          height="10.129"
          viewBox="0 0 10.129 10.129"
        >
          <path
            d="M9.84,7.158l-2.216-.95a.475.475,0,0,0-.554.137l-.981,1.2A7.333,7.333,0,0,1,2.584,4.038l1.2-.981A.474.474,0,0,0,3.919,2.5L2.969.287A.478.478,0,0,0,2.425.012L.368.487A.475.475,0,0,0,0,.95a9.178,9.178,0,0,0,9.179,9.179.475.475,0,0,0,.463-.368L10.117,7.7a.481.481,0,0,0-.277-.546Z"
            transform="translate(0 0)"
          />
        </svg>
      );
    }
    case SVG_TYPE.MEDIA_POWER: {
      return (
        <svg
          className={`svg svg--media_power ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="10.604"
          height="10.604"
          viewBox="0 0 10.604 10.604"
        >
          <path
            className="a"
            d="M15.14,5.052l-1-1L12.162,6.028,11.039,4.906l1.977-1.977-1-1L10.038,3.9,8.769,2.636l-.958.958,5.663,5.663.958-.958L13.163,7.029ZM12.6,9.38,7.688,4.471C6.628,5.742,5.426,7.706,6.257,9.4L4.794,10.858a.887.887,0,0,0,0,1.251l.164.164a.887.887,0,0,0,1.251,0l1.463-1.463c1.69.831,3.653-.371,4.924-1.431Z"
            transform="translate(-4.536 -1.928)"
          />
        </svg>
      );
    }
    case SVG_TYPE.MEDIA_HEAT: {
      return (
        <svg
          className={`svg svg--media_heat ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="14.866"
          height="9.91"
          viewBox="0 0 14.866 9.91"
        >
          <path
            className="a"
            d="M14.51,12.76a2.981,2.981,0,0,1-1.495-.591,1,1,0,0,0-1.244,0A3.234,3.234,0,0,1,8.01,12.13a.958.958,0,0,0-1.205.046,3.235,3.235,0,0,1-3.748-.044.973.973,0,0,0-1.216.052,2.927,2.927,0,0,1-1.489.578A.4.4,0,0,0,0,13.168V14a.407.407,0,0,0,.431.413,4.639,4.639,0,0,0,2.05-.669,4.949,4.949,0,0,0,4.956,0,4.949,4.949,0,0,0,4.956,0,4.772,4.772,0,0,0,2.042.666A.407.407,0,0,0,14.866,14v-.816a.414.414,0,0,0-.356-.421Zm0-3.717a2.981,2.981,0,0,1-1.495-.591,1,1,0,0,0-1.244,0A3.234,3.234,0,0,1,8.01,8.413.958.958,0,0,0,6.8,8.459a3.235,3.235,0,0,1-3.748-.044.973.973,0,0,0-1.216.052,2.927,2.927,0,0,1-1.489.578A.4.4,0,0,0,0,9.451v.831a.407.407,0,0,0,.431.413,4.639,4.639,0,0,0,2.05-.669,4.949,4.949,0,0,0,4.956,0,4.949,4.949,0,0,0,4.956,0,4.772,4.772,0,0,0,2.042.666.407.407,0,0,0,.431-.413V9.463a.414.414,0,0,0-.356-.421Zm0-3.717a3,3,0,0,1-1.495-.591,1,1,0,0,0-1.244,0A3.234,3.234,0,0,1,8.01,4.7.958.958,0,0,0,6.8,4.742,3.235,3.235,0,0,1,3.056,4.7.973.973,0,0,0,1.84,4.75a2.927,2.927,0,0,1-1.489.578A.4.4,0,0,0,0,5.733v.831a.407.407,0,0,0,.431.413,4.639,4.639,0,0,0,2.05-.669,4.949,4.949,0,0,0,4.956,0,4.949,4.949,0,0,0,4.956,0,4.772,4.772,0,0,0,2.042.666.407.407,0,0,0,.431-.413V5.746a.414.414,0,0,0-.356-.421Z"
            transform="translate(0 -4.503)"
          />
        </svg>
      );
    }
    case SVG_TYPE.CHECKED: {
      return (
        <svg
          className={`svg svg--checked ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="22.248"
          height="22.248"
          viewBox="0 0 22.248 22.248"
        >
          <g transform="translate(-1629.72 -458.423)">
            <circle className="a" cx="11.124" cy="11.124" r="11.124" transform="translate(1629.72 458.423)" />
            <path className="b" d="M7567,33.69l3.615,3.615,7.252-7.253" transform="translate(-5931.1 435.854)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.BLUE_HOME: {
      return (
        <svg
          className={`svg svg--blueHome ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="20.129"
          height="22.143"
          viewBox="0 0 20.129 22.143"
        >
          <g transform="translate(1 1)">
            <path
              className="a"
              d="M4.5,10.05,13.564,3l9.064,7.05V21.129a2.014,2.014,0,0,1-2.014,2.014H6.514A2.014,2.014,0,0,1,4.5,21.129Z"
              transform="translate(-4.5 -3)"
            />
            <path className="a" d="M13.5,30.124V18h7.275V30.124" transform="translate(-8.073 -9.981)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.MAP: {
      return (
        <svg
          className={`svg svg--map ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="20.621"
          height="18.929"
          viewBox="0 0 20.621 18.929"
        >
          <g transform="translate(-329.439 -99.85)">
            <g transform="translate(330.439 100.85)">
              <path
                className="a"
                d="M1.5,6.386V19.929l5.925-3.386L14.2,19.929l5.925-3.386V3L14.2,6.386,7.425,3Z"
                transform="translate(-1.5 -3)"
              />
              <path className="a" d="M12,3V16.543" transform="translate(-6.075 -3)" />
              <path className="a" d="M24,9V22.543" transform="translate(-11.304 -5.614)" />
            </g>
          </g>
        </svg>
      );
    }
    case SVG_TYPE.FILE: {
      return (
        <svg
          className={`svg svg--map ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="14.335"
          height="17.669"
          viewBox="0 0 14.335 17.669"
        >
          <g transform="translate(0.5 0.5)">
            <path
              className="a"
              d="M14.335,3H7.667A1.667,1.667,0,0,0,6,4.667V18a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,19.335,18V8Z"
              transform="translate(-6 -3)"
            />
            <path className="a" d="M21,3V8h5" transform="translate(-12.665 -3)" />
            <path className="a" d="M18.668,19.5H12" transform="translate(-8.666 -10.332)" />
            <path className="a" d="M18.668,25.5H12" transform="translate(-8.666 -12.998)" />
            <path className="a" d="M13.667,13.5H12" transform="translate(-8.666 -7.666)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.MAIL: {
      return (
        <svg
          className="svg svg--mail"
          xmlns="http://www.w3.org/2000/svg"
          width="14.074"
          height="11.259"
          viewBox="0 0 14.074 11.259"
        >
          <path
            className="a"
            d="M15.667,6H4.407a1.406,1.406,0,0,0-1.4,1.407L3,15.852a1.412,1.412,0,0,0,1.407,1.407H15.667a1.412,1.412,0,0,0,1.407-1.407V7.407A1.412,1.412,0,0,0,15.667,6Zm0,2.815-5.63,3.519L4.407,8.815V7.407l5.63,3.519,5.63-3.519Z"
            transform="translate(-3 -6)"
          />
        </svg>
      );
    }
    case SVG_TYPE.CLOSE: {
      return (
        <svg
          className={`svg svg--close ${className}`}
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
            fill="black"
          />
        </svg>
      );
    }
    case SVG_TYPE.EXIT: {
      return (
        <svg
          className={`svg svg--exit ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="9.707"
          height="9.707"
          viewBox="0 0 9.707 9.707"
        >
          <g className="a" transform="translate(-330.896 -409.146)">
            <line className="b" x1="9" y2="9" transform="translate(331.25 409.5)" />
            <line className="b" x2="9" y2="9" transform="translate(331.25 409.5)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.RESTORE: {
      return (
        <svg
          className="svg svg--restore"
          xmlns="http://www.w3.org/2000/svg"
          width="18.286"
          height="12.41"
          viewBox="0 0 18.286 12.41"
        >
          <path
            className="a"
            d="M17.535,8.79v3.661H5.694L8.912,9.164,7.646,7.875l-5.4,5.492,5.4,5.492,1.266-1.289L5.694,14.282H19.335V8.79Z"
            transform="translate(-1.549 -7.162)"
          />
        </svg>
      );
    }

    case SVG_TYPE.SORT: {
      return (
        <svg
          className="svg svg--sort"
          xmlns="http://www.w3.org/2000/svg"
          width="19.832"
          height="19.833"
          viewBox="0 0 19.832 19.833"
        >
          <g
            id="Icon_awesome-sort-alpha-down-alt"
            data-name="Icon awesome-sort-alpha-down-alt"
            transform="translate(0 -2.25)"
            fill="none"
          >
            <path
              d="M7.792,16.416H5.667V2.958a.708.708,0,0,0-.708-.708H3.542a.708.708,0,0,0-.708.708V16.416H.708a.709.709,0,0,0-.5,1.209l3.542,4.25a.708.708,0,0,0,1,0l3.542-4.25A.709.709,0,0,0,7.792,16.416ZM12.75,10.75h5.667a.708.708,0,0,0,.708-.708V8.625a.708.708,0,0,0-.708-.708H15.937L18.649,4.8a1.417,1.417,0,0,0,.475-1.059v-.78a.708.708,0,0,0-.708-.708H12.75a.708.708,0,0,0-.708.708V4.375a.708.708,0,0,0,.708.708h2.479L12.517,8.2a1.417,1.417,0,0,0-.475,1.059v.78A.708.708,0,0,0,12.75,10.75Zm7.042,10.387-2.624-7.083a.708.708,0,0,0-.667-.47H14.666a.708.708,0,0,0-.667.47l-2.624,7.083a.708.708,0,0,0,.667.946h1.1a.708.708,0,0,0,.674-.491l.2-.572h3.143l.2.572a.708.708,0,0,0,.676.491h1.1a.708.708,0,0,0,.667-.946Zm-4.934-2.6.726-2.125.726,2.125Z"
              stroke="none"
            />
            <path
              d="M 4.250909328460693 19.35211563110352 L 5.030646800994873 18.41643142700195 L 3.471173524856567 18.41643142700195 L 4.250909328460693 19.35211563110352 M 18.02309417724609 22.0830135345459 C 17.71590423583984 22.0830135345459 17.4436149597168 21.88494682312012 17.34911346435547 21.59250068664551 L 17.15387344360352 21.02053070068359 L 14.01070308685303 21.02053070068359 L 13.81502246856689 21.59250068664551 C 13.72051239013672 21.88497161865234 13.44582271575928 22.0828971862793 13.14079284667969 22.08300971984863 L 12.04156303405762 22.08300971984863 C 11.81130218505859 22.0828914642334 11.59546279907227 21.97084045410156 11.46285247802734 21.78259086608887 C 11.3302526473999 21.59434127807617 11.2974328994751 21.35337066650391 11.37486267089844 21.13651084899902 L 13.99872303009033 14.05336093902588 C 14.09936237335205 13.77139091491699 14.36643218994141 13.58315086364746 14.66589260101318 13.58315086364746 L 16.50045204162598 13.58315086364746 C 16.79984283447266 13.58312034606934 17.06693267822266 13.77133083343506 17.1676025390625 14.05330085754395 L 19.7914924621582 21.13651084899902 C 19.86892318725586 21.35337066650391 19.83610343933105 21.59434127807617 19.70349311828613 21.78259086608887 C 19.57089233398438 21.97084045410156 19.35505294799805 22.0828914642334 19.12478256225586 22.08300971984863 L 18.02511215209961 22.08300971984863 C 18.02443504333496 22.08301162719727 18.02376937866211 22.0830135345459 18.02309417724609 22.0830135345459 Z M 16.30876350402832 18.54140090942383 L 15.58317279815674 16.41643142700195 L 14.85758304595947 18.54140090942383 L 16.30876350402832 18.54140090942383 Z M 4.250911235809326 22.08267974853516 C 4.069707870483398 22.08267974853516 3.888502597808838 22.01358032226562 3.750212669372559 21.87538146972656 L 0.2086126506328583 17.62545013427734 C -0.2371873408555984 17.17965126037598 0.08022265881299973 16.41643142700195 0.7084126472473145 16.41643142700195 L 2.833382606506348 16.41643142700195 L 2.833382606506348 2.958320617675781 C 2.833382606506348 2.567130565643311 3.1505126953125 2.250000476837158 3.541702747344971 2.250000476837158 L 4.958342552185059 2.250000476837158 C 5.349542617797852 2.250000476837158 5.666672706604004 2.567130565643311 5.666672706604004 2.958320617675781 L 5.666672706604004 16.41643142700195 L 7.791632652282715 16.41643142700195 C 8.42115306854248 16.41643142700195 8.73680305480957 17.18054008483887 8.293212890625 17.62545013427734 L 4.751602649688721 21.87538146972656 C 4.613317489624023 22.01358032226562 4.432115077972412 22.08267974853516 4.250911235809326 22.08267974853516 Z M 18.41646194458008 10.7498607635498 L 12.74988269805908 10.7498607635498 C 12.35869312286377 10.7498607635498 12.04156303405762 10.43273067474365 12.04156303405762 10.04154014587402 L 12.04156303405762 9.26106071472168 C 12.04152297973633 8.85637092590332 12.21456241607666 8.470980644226074 12.51702308654785 8.202120780944824 L 15.22901248931885 5.083290576934814 L 12.74988269805908 5.083290576934814 C 12.35869312286377 5.083290576934814 12.04156303405762 4.766160488128662 12.04156303405762 4.374960422515869 L 12.04156303405762 2.958320617675781 C 12.04156303405762 2.567130565643311 12.35869312286377 2.250000476837158 12.74988269805908 2.250000476837158 L 18.41646194458008 2.250000476837158 C 18.80765342712402 2.250000476837158 19.12478256225586 2.567130565643311 19.12478256225586 2.958320617675781 L 19.12478256225586 3.738800525665283 C 19.12482261657715 4.143490314483643 18.9517822265625 4.528880596160889 18.64932250976562 4.797740459442139 L 15.93733310699463 7.916570663452148 L 18.41646194458008 7.916570663452148 C 18.80765342712402 7.916570663452148 19.12478256225586 8.233700752258301 19.12478256225586 8.624900817871094 L 19.12478256225586 10.04154014587402 C 19.12478256225586 10.43273067474365 18.80765342712402 10.7498607635498 18.41646194458008 10.7498607635498 Z"
              stroke="none"
              fill="#000"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.GROUP: {
      return (
        <svg
          className="svg svg--group"
          xmlns="http://www.w3.org/2000/svg"
          width="23.334"
          height="23.352"
          viewBox="0 0 23.334 23.352"
        >
          <path
            id="Icon_awesome-layer-group"
            data-name="Icon awesome-layer-group"
            d="M.517,6.167l9.706,4.4a1.067,1.067,0,0,0,.887,0l9.706-4.4a.931.931,0,0,0,0-1.668L11.11.1a1.067,1.067,0,0,0-.887,0L.517,4.5a.931.931,0,0,0,0,1.668Zm20.3,3.678-2.42-1.1L11.661,11.8a2.4,2.4,0,0,1-1.988,0L2.938,8.749.517,9.846a.93.93,0,0,0,0,1.667l9.706,4.4a1.07,1.07,0,0,0,.887,0l9.706-4.4a.93.93,0,0,0,0-1.667Zm0,5.325-2.411-1.093-6.744,3.057a2.4,2.4,0,0,1-1.988,0L2.929,14.078.517,15.171a.93.93,0,0,0,0,1.667l9.706,4.4a1.07,1.07,0,0,0,.887,0l9.706-4.4a.93.93,0,0,0,0-1.667Z"
            transform="translate(1 1.01)"
            fill="none"
            stroke="#000"
            strokeWidth="2"
          />
        </svg>
      );
    }

    case SVG_TYPE.FILTERING: {
      return (
        <svg className="svg svg--filtering" xmlns="http://www.w3.org/2000/svg" width="19" height="17.5" viewBox="0 0 19 17.5">
          <g
            id="Icon_feather-filter"
            data-name="Icon feather-filter"
            transform="translate(-1 -2.5)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18,4.5H3l6,7.095V16.5L12,18v-6.4Z" stroke="none" />
            <path
              d="M 2.999998092651367 4.499998092651367 L 8.999999046325684 11.59499931335449 L 8.999999046325684 16.5 L 11.99999904632568 18 L 11.99999904632568 11.59499931335449 L 18 4.499998092651367 L 2.999998092651367 4.499998092651367 M 2.999998092651367 2.499998092651367 L 18 2.499998092651367 C 18.77864837646484 2.499998092651367 19.48651885986328 2.951919555664062 19.81423950195312 3.658248901367188 C 20.14194869995117 4.364568710327148 20.02992820739746 5.1968994140625 19.52713966369629 5.791448593139648 L 13.99999904632568 12.32729244232178 L 13.99999904632568 18 C 13.99999904632568 18.69315910339355 13.64109897613525 19.33688926696777 13.05145835876465 19.7012996673584 C 12.46182918548584 20.06571006774902 11.72554779052734 20.09883880615234 11.10556888580322 19.78884887695312 L 8.105568885803223 18.28884887695312 C 7.427999496459961 17.95006942749023 6.999999046325684 17.25753974914551 6.999999046325684 16.5 L 6.999999046325684 12.32729244232178 L 1.472858428955078 5.791448593139648 C 0.9700698852539062 5.1968994140625 0.8580493927001953 4.364568710327148 1.185758590698242 3.658248901367188 C 1.513479232788086 2.951919555664062 2.221349716186523 2.499998092651367 2.999998092651367 2.499998092651367 Z"
              stroke="none"
              fill="#000"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.GENERATE: {
      return (
        <svg className="svg svg--generate" xmlns="http://www.w3.org/2000/svg" width="20" height="24.5" viewBox="0 0 20 24.5">
          <g id="Icon_feather-file-text" data-name="Icon feather-file-text" transform="translate(-5 -2)">
            <path
              id="Path_5274"
              data-name="Path 5274"
              d="M17.25,3h-9A2.25,2.25,0,0,0,6,5.25v18A2.25,2.25,0,0,0,8.25,25.5h13.5A2.25,2.25,0,0,0,24,23.25V9.75Z"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5275"
              data-name="Path 5275"
              d="M21,3V9.75h6.75"
              transform="translate(-3.75)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5276"
              data-name="Path 5276"
              d="M21,19.5H12"
              transform="translate(-1.5 -4.125)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5277"
              data-name="Path 5277"
              d="M21,25.5H12"
              transform="translate(-1.5 -5.625)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5278"
              data-name="Path 5278"
              d="M14.25,13.5H12"
              transform="translate(-1.5 -2.625)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.SAVE: {
      return (
        <svg
          className="svg svg--save"
          xmlns="http://www.w3.org/2000/svg"
          width="21.833"
          height="21.833"
          viewBox="0 0 21.833 21.833"
        >
          <g id="Icon_feather-save" data-name="Icon feather-save" transform="translate(-3.5 -3.5)">
            <path
              id="Path_5267"
              data-name="Path 5267"
              d="M22.129,24.333H6.7a2.2,2.2,0,0,1-2.2-2.2V6.7A2.2,2.2,0,0,1,6.7,4.5h12.12l5.509,5.509v12.12A2.2,2.2,0,0,1,22.129,24.333Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5268"
              data-name="Path 5268"
              d="M21.518,28.315V19.5H10.5v8.815"
              transform="translate(-1.593 -3.982)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5269"
              data-name="Path 5269"
              d="M10.5,4.5v5.509h8.815"
              transform="translate(-1.593 0)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.LOAD: {
      return (
        <svg className="svg svg--load" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
          <g id="Icon_feather-download" data-name="Icon feather-download" transform="translate(-3.5 -3.5)">
            <path
              id="Path_5281"
              data-name="Path 5281"
              d="M23.5,22.5v4.222a2.111,2.111,0,0,1-2.111,2.111H6.611A2.111,2.111,0,0,1,4.5,26.722V22.5"
              transform="translate(0 -5.333)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5282"
              data-name="Path 5282"
              d="M10.5,15l5.278,5.278L21.056,15"
              transform="translate(-1.778 -3.111)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_5283"
              data-name="Path 5283"
              d="M18,17.167V4.5"
              transform="translate(-4)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.SMALL_FILTER: {
      return (
        <svg
          className="svg svg--small_filter"
          xmlns="http://www.w3.org/2000/svg"
          width="11.413"
          height="12.413"
          viewBox="0 0 11.413 12.413"
        >
          <g id="Group_13099" data-name="Group 13099" transform="translate(-905.794 -60.044)">
            <g
              id="Icon_feather-filter"
              data-name="Icon feather-filter"
              transform="translate(905.152 59.5)"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.5,4.5H3L6,8.048V10.5l1.5.75v-3.2Z" stroke="none" />
              <path
                d="M 2.999997138977051 4.500004768371582 L 6.000016689300537 8.047514915466309 L 6.000016689300537 10.50002479553223 L 7.500016689300537 11.25002479553223 L 7.500016689300537 8.047514915466309 L 10.50003623962402 4.500004768371582 L 2.999997138977051 4.500004768371582 M 2.999997138977051 3.500004768371582 L 10.50003623962402 3.500004768371582 C 10.88936614990234 3.500004768371582 11.24329662322998 3.725964546203613 11.4071569442749 4.079124450683594 C 11.57101631164551 4.432294845581055 11.51500701904297 4.848454475402832 11.26360702514648 5.145734786987305 L 8.500017166137695 8.413667678833008 L 8.500017166137695 11.25002479553223 C 8.500017166137695 11.59660530090332 8.320566177368164 11.91846466064453 8.025747299194336 12.10067462921143 C 7.730926513671875 12.28288459777832 7.362786293029785 12.29944515228271 7.052806854248047 12.14445495605469 L 5.552806854248047 11.39445495605469 C 5.214016914367676 11.22506523132324 5.000016212463379 10.87879467010498 5.000016212463379 10.50002479553223 L 5.000016212463379 8.413667678833008 L 2.23642635345459 5.145734786987305 C 1.985026359558105 4.848454475402832 1.929017066955566 4.432294845581055 2.092876434326172 4.079124450683594 C 2.256736755371094 3.725964546203613 2.610666275024414 3.500004768371582 2.999997138977051 3.500004768371582 Z"
                stroke="none"
                fill="#000"
              />
            </g>
            <line
              id="Line_672"
              data-name="Line 672"
              x1="10"
              y1="11"
              transform="translate(906.5 60.75)"
              fill="none"
              stroke="#de4747"
              strokeLinecap="round"
              strokeWidth="1"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.CLEAR: {
      return (
        <svg className="svg svg--clear" xmlns="http://www.w3.org/2000/svg" width="8.82" height="9.997" viewBox="0 0 8.82 9.997">
          <path
            id="Icon_material-money-off"
            data-name="Icon material-money-off"
            d="M10.778,6.666c.989,0,1.355.472,1.389,1.166h1.227a2.214,2.214,0,0,0-1.783-2.116V4.5H9.945V5.7a3.292,3.292,0,0,0-.822.3l.816.816A2.178,2.178,0,0,1,10.778,6.666ZM6.8,5.089l-.705.705L8,7.7c0,1.155.866,1.783,2.172,2.172l1.949,1.949a1.537,1.537,0,0,1-1.344.505c-1.144,0-1.594-.511-1.655-1.166H7.9a2.327,2.327,0,0,0,2.044,2.127V14.5h1.666V13.3a2.779,2.779,0,0,0,1.361-.622L14.2,13.914l.705-.705Z"
            transform="translate(-6.09 -4.5)"
          />
        </svg>
      );
    }

    case SVG_TYPE.SMALL_ARROW: {
      return (
        <svg
          className="svg svg--small--arrow"
          xmlns="http://www.w3.org/2000/svg"
          width="9.162"
          height="5.995"
          viewBox="0 0 9.162 5.995"
        >
          <path
            id="Path_5251"
            data-name="Path 5251"
            d="M-8394.356-10140.167l-3.167,3.167-3.167-3.167"
            transform="translate(8402.104 10141.581)"
            fill="none"
            stroke="#3d3d3d"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </svg>
      );
    }

    case SVG_TYPE.ELLIPSE: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
          <circle id="Ellipse_334" data-name="Ellipse 334" cx="3" cy="3" r="3" fill="#ff9100" />
        </svg>
      );
    }
    case SVG_TYPE.LIGHT_MEETING: {
      return (
        <svg
          className={`svg svg--light-meeting ${className}`}
          xmlns="http://www.w3.org/2000/svg"
          width="21.737"
          height="17.966"
          viewBox="0 0 21.737 17.966"
        >
          <g transform="translate(-1 -4)">
            <path
              className="a"
              d="M16.581,28.155V26.27a3.77,3.77,0,0,0-3.77-3.77H5.27A3.77,3.77,0,0,0,1.5,26.27v1.885"
              transform="translate(0 -6.689)"
            />
            <path
              className="a"
              d="M15.041,8.27A3.77,3.77,0,1,1,11.27,4.5,3.77,3.77,0,0,1,15.041,8.27Z"
              transform="translate(-2.23)"
            />
            <path className="a" d="M32.828,28.228V26.343A3.77,3.77,0,0,0,30,22.7" transform="translate(-10.591 -6.762)" />
            <path className="a" d="M24,4.7A3.77,3.77,0,0,1,24,12" transform="translate(-8.361 -0.072)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.LIGHT_PHONE: {
      return (
        <svg
          className="svg svg--light-phone"
          xmlns="http://www.w3.org/2000/svg"
          width="18.407"
          height="18.441"
          viewBox="0 0 18.407 18.441"
        >
          <path
            className="a"
            d="M13.951,4.834a4.167,4.167,0,0,1,3.292,3.292M13.951,1.5a7.5,7.5,0,0,1,6.626,6.618m-.833,6.651v2.5a1.667,1.667,0,0,1-1.817,1.667,16.494,16.494,0,0,1-7.193-2.559,16.252,16.252,0,0,1-5-5A16.494,16.494,0,0,1,3.175,4.15,1.667,1.667,0,0,1,4.833,2.333h2.5A1.667,1.667,0,0,1,9,3.767a10.7,10.7,0,0,0,.583,2.342,1.667,1.667,0,0,1-.375,1.759L8.15,8.926a13.335,13.335,0,0,0,5,5l1.058-1.058a1.667,1.667,0,0,1,1.759-.375,10.7,10.7,0,0,0,2.342.583A1.667,1.667,0,0,1,19.744,14.769Z"
            transform="translate(-2.667 -1.003)"
          />
        </svg>
      );
    }
    case SVG_TYPE.LIGHT_FILE: {
      return (
        <svg
          className="svg svg--light-file"
          xmlns="http://www.w3.org/2000/svg"
          width="14.335"
          height="17.669"
          viewBox="0 0 14.335 17.669"
        >
          <g transform="translate(0.5 0.5)">
            <path
              className="a"
              d="M14.335,3H7.667A1.667,1.667,0,0,0,6,4.667V18a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,19.335,18V8Z"
              transform="translate(-6 -3)"
            />
            <path className="a" d="M21,3V8h5" transform="translate(-12.665 -3)" />
            <path className="a" d="M18.668,19.5H12" transform="translate(-8.666 -10.332)" />
            <path className="a" d="M18.668,25.5H12" transform="translate(-8.666 -12.998)" />
            <path className="a" d="M13.667,13.5H12" transform="translate(-8.666 -7.666)" />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.MEETING: {
      return (
        <svg
          className="svg svg--meeting"
          xmlns="http://www.w3.org/2000/svg"
          width="21.737"
          height="17.966"
          viewBox="0 0 21.737 17.966"
        >
          <g transform="translate(-1 -4)">
            <path
              className="a"
              d="M16.581,28.155V26.27a3.77,3.77,0,0,0-3.77-3.77H5.27A3.77,3.77,0,0,0,1.5,26.27v1.885"
              transform="translate(0 -6.689)"
            />
            <path
              className="a"
              d="M15.041,8.27A3.77,3.77,0,1,1,11.27,4.5,3.77,3.77,0,0,1,15.041,8.27Z"
              transform="translate(-2.23)"
            />
            <path className="a" d="M32.828,28.228V26.343A3.77,3.77,0,0,0,30,22.7" transform="translate(-10.591 -6.762)" />
            <path className="a" d="M24,4.7A3.77,3.77,0,0,1,24,12" transform="translate(-8.361 -0.072)" />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.REPORTS: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14.335" height="17.669" viewBox="0 0 14.335 17.669">
          <g id="Icon_feather-file-text" data-name="Icon feather-file-text" transform="translate(0.5 0.5)">
            <path
              id="Path_5171"
              data-name="Path 5171"
              d="M14.335,3H7.667A1.667,1.667,0,0,0,6,4.667V18a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,19.335,18V8Z"
              transform="translate(-6 -3)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_5172"
              data-name="Path 5172"
              d="M21,3V8h5"
              transform="translate(-12.665 -3)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_5173"
              data-name="Path 5173"
              d="M18.668,19.5H12"
              transform="translate(-8.666 -10.332)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_5174"
              data-name="Path 5174"
              d="M18.668,25.5H12"
              transform="translate(-8.666 -12.998)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_5175"
              data-name="Path 5175"
              d="M13.667,13.5H12"
              transform="translate(-8.666 -7.666)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.ADD_NOTIFICATION: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" className="svg svg--add_notification">
          <g id="Group_10496" data-name="Group 10496" transform="translate(-1305 -83)">
            <rect
              id="Rectangle_2387"
              data-name="Rectangle 2387"
              className={`cls-1 ${className}`}
              width="33"
              height="33"
              rx="8"
              transform="translate(1305 83)"
            />
            <g id="Group_10552" data-name="Group 10552">
              <line
                id="Line_626"
                data-name="Line 626"
                className={`cls-2 ${className}`}
                x2="16.391"
                transform="translate(1313.305 107.441)"
              />
              <line
                id="Line_627"
                data-name="Line 627"
                className={`cls-2 ${className}`}
                x2="16.391"
                transform="translate(1313.305 104.254)"
              />
              <g id="Rectangle_2388" data-name="Rectangle 2388" className={`cls-2 ${className}`} transform="translate(1314 91)">
                <rect className="cls-3" width="15" height="10" rx="2" />
                <rect className="cls-4" x="1" y="1" width="13" height="8" rx="1" />
              </g>
            </g>
          </g>
        </svg>
      );
    }

    case SVG_TYPE.NOTE: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.335"
          height="17.669"
          viewBox="0 0 14.335 17.669"
          className="svg svg--note"
        >
          <g id="Icon_feather-file-text" data-name="Icon feather-file-text" transform="translate(0.5 0.5)">
            <path
              id="Path_5171"
              data-name="Path 5171"
              d="M14.335,3H7.667A1.667,1.667,0,0,0,6,4.667V18a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,19.335,18V8Z"
              transform="translate(-6 -3)"
              fill="none"
              stroke="#000"
            />
            <path
              id="Path_5172"
              data-name="Path 5172"
              d="M21,3V8h5"
              transform="translate(-12.665 -3)"
              fill="none"
              stroke="#000"
            />
            <path
              id="Path_5173"
              data-name="Path 5173"
              d="M18.668,19.5H12"
              transform="translate(-8.666 -10.332)"
              fill="none"
              stroke="#000"
            />
            <path
              id="Path_5174"
              data-name="Path 5174"
              d="M18.668,25.5H12"
              transform="translate(-8.666 -12.998)"
              fill="none"
              stroke="#000"
            />
            <path
              id="Path_5175"
              data-name="Path 5175"
              d="M13.667,13.5H12"
              transform="translate(-8.666 -7.666)"
              fill="none"
              stroke="#000"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.CONTACT: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11.844" height="11.866" viewBox="0 0 11.844 11.866">
          <g id="Group_10687" data-name="Group 10687" transform="translate(-22.809 -15.826)">
            <path
              id="Icon_feather-phone-call"
              data-name="Icon feather-phone-call"
              d="M10.5,3.768a2.835,2.835,0,0,1,2.24,2.24M10.5,1.5A5.1,5.1,0,0,1,15.012,6m-.567,4.525v1.7a1.134,1.134,0,0,1-1.236,1.134,11.221,11.221,0,0,1-4.893-1.741,11.057,11.057,0,0,1-3.4-3.4A11.221,11.221,0,0,1,3.172,3.3,1.134,1.134,0,0,1,4.3,2.067H6a1.134,1.134,0,0,1,1.134.975,7.28,7.28,0,0,0,.4,1.593,1.134,1.134,0,0,1-.255,1.2l-.72.72a9.072,9.072,0,0,0,3.4,3.4l.72-.72a1.134,1.134,0,0,1,1.2-.255,7.28,7.28,0,0,0,1.593.4A1.134,1.134,0,0,1,14.445,10.527Z"
              transform="translate(19.642 14.326)"
              fill="#15b791"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.APPOINTMENT: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.737"
          height="17.966"
          viewBox="0 0 21.737 17.966"
          className="svg svg--appointment"
        >
          <g id="Icon_feather-users" data-name="Icon feather-users" transform="translate(-1 -4)">
            <path
              id="Path_5190"
              data-name="Path 5190"
              d="M16.581,28.155V26.27a3.77,3.77,0,0,0-3.77-3.77H5.27A3.77,3.77,0,0,0,1.5,26.27v1.885"
              transform="translate(0 -6.689)"
              fill="#004a9e"
              stroke="#004a9e"
            />
            <path
              id="Path_5191"
              data-name="Path 5191"
              d="M15.041,8.27A3.77,3.77,0,1,1,11.27,4.5,3.77,3.77,0,0,1,15.041,8.27Z"
              transform="translate(-2.23)"
              fill="#004a9e"
            />
            <path
              id="Path_5192"
              data-name="Path 5192"
              d="M32.828,28.228V26.343A3.77,3.77,0,0,0,30,22.7"
              transform="translate(-10.591 -6.762)"
              fill="#004a9e"
              stroke="#004a9e"
            />
            <path
              id="Path_5193"
              data-name="Path 5193"
              d="M24,4.7A3.77,3.77,0,0,1,24,12"
              transform="translate(-8.361 -0.072)"
              fill="#004a9e"
              stroke="#004a9e"
            />
          </g>
        </svg>
      );
    }

    case SVG_TYPE.UPLOAD: {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14.564"
          height="17.706"
          viewBox="0 0 14.564 17.706"
          className="svg svg--upload"
        >
          <g id="Icon_feather-share" data-name="Icon feather-share" transform="translate(-5 -2)">
            <path
              id="Path_5205"
              data-name="Path 5205"
              d="M6,18v6.282a1.571,1.571,0,0,0,1.571,1.571h9.423a1.571,1.571,0,0,0,1.571-1.571V18"
              transform="translate(0 -7.147)"
              fill="none"
              stroke="#4d4d4d"
            />
            <path
              id="Path_5206"
              data-name="Path 5206"
              d="M18.282,6.141,15.141,3,12,6.141"
              transform="translate(-2.859)"
              fill="none"
              stroke="#4d4d4d"
            />
            <path
              id="Path_5207"
              data-name="Path 5207"
              d="M18,3V13.209"
              transform="translate(-5.718)"
              fill="none"
              stroke="#4d4d4d"
            />
          </g>
        </svg>
      );
    }
    case SVG_TYPE.ACT: {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="18.875" viewBox="0 0 15.5 18.875">
          <g id="Icon_feather-file-text" data-name="Icon feather-file-text" transform="translate(-5 -2)">
            <path
              id="Path_5214"
              data-name="Path 5214"
              d="M14.438,3H7.688A1.688,1.688,0,0,0,6,4.688v13.5a1.687,1.687,0,0,0,1.688,1.688H17.813A1.687,1.687,0,0,0,19.5,18.188V8.063Z"
              fill="none"
              stroke="#15b791"
            />
            <path
              id="Path_5215"
              data-name="Path 5215"
              d="M21,3V7.125h4.125"
              transform="translate(-5.625)"
              fill="none"
              stroke="#15b791"
            />
            <path
              id="Path_5216"
              data-name="Path 5216"
              d="M17.5,19.5H12"
              transform="translate(-2 -7.219)"
              fill="none"
              stroke="#15b791"
            />
            <path
              id="Path_5217"
              data-name="Path 5217"
              d="M17.5,25.5H12"
              transform="translate(-2 -9.844)"
              fill="none"
              stroke="#15b791"
            />
            <path
              id="Path_5218"
              data-name="Path 5218"
              d="M13.375,13.5H12"
              transform="translate(-2.536 -4.594)"
              fill="none"
              stroke="#15b791"
            />
          </g>
        </svg>
      );
    }

    default: {
      return null;
    }
  }
};

export default SVG;
